import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable, OnInit } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { API_MYM_ENDPOINT } from '../core/DI';
import { CarDetails } from '../core/models/car-details.model';
import { CarMake } from '../core/models/car-make.model';
import { CarModel } from '../core/models/car-model.model';
import { CarOptionCombinedDescription } from '../core/models/car-option.model';
import { CarSubmodel } from '../core/models/car-submodel.model';
import { CarYear } from '../core/models/car-year.model';
import { MakeYearModel } from '../core/models/make-year-model.model';
import { VehicleOemDataDtoResponse } from '../core/models/vehicule-oem-data.dto-response';
import { Helper } from '../shared/helper';
import { User } from '../core/User';


@Injectable()
export class MakeYearModelService {
  apiEndpoint: string;
  staggeredCar: boolean;
  region: string = "Canada";
  constructor(@Inject(API_MYM_ENDPOINT) apiEndpoint: string,
    private http: HttpClient) {
    this.apiEndpoint = apiEndpoint;
    this.region = sessionStorage.getItem("vehicleCountry");
  }
  ngOnInit() {
    if (User.showRegionToggle) {
      if (sessionStorage.getItem("vehicleCountry") == null) {
        sessionStorage.setItem("vehicleCountry", this.region)
      }
      else {
        this.region = sessionStorage.getItem("vehicleCountry")
      }
    }
    else {
      sessionStorage.setItem("vehicleCountry", this.region)
    }

  }
  getCarMakes(region = "Canada"): Promise<CarMake[]> {
    var currentRegion = sessionStorage.getItem("vehicleCountry");
    this.staggeredCar = false;
    this.region = currentRegion != null ? currentRegion : region;
    const api = `${this.apiEndpoint}/${this.region}/makes/`;
    return this.http.get<CarMake[]>(api).toPromise();
  }

  getYears(make: string): Promise<CarYear[]> {
    var currentRegion = sessionStorage.getItem("vehicleCountry");
    this.staggeredCar = false;
    this.region = currentRegion != null ? currentRegion : "Canada";
    const api = `${this.apiEndpoint}/${this.region}/`
      + `makes/${Helper.encodeURIComponent2(make)}/`
      + `years`;
    return this.http.get<CarYear[]>(api).toPromise();
  }

  getCarModels(make: string, year: string): Promise<CarModel[]> {
    var currentRegion = sessionStorage.getItem("vehicleCountry");
    this.staggeredCar = false;
    this.region = currentRegion != null ? currentRegion : "Canada";
    const api = `${this.apiEndpoint}/${this.region}/`
      + `makes/${Helper.encodeURIComponent2(make)}/`
      + `years/${Helper.encodeURIComponent2(year)}/`
      + `models`;
    return this.http.get<CarModel[]>(api).toPromise();
  }

  getCarSubModels(make: string, year: string, model: string): Promise<CarSubmodel[]> {
    var currentRegion = sessionStorage.getItem("vehicleCountry");
    this.staggeredCar = false;
    this.region = currentRegion != null ? currentRegion : "Canada";
    const api = `${this.apiEndpoint}/${this.region}/`
      + `makes/${Helper.encodeURIComponent2(make)}/`
      + `years/${Helper.encodeURIComponent2(year)}/`
      + `models/${Helper.encodeURIComponent2(model)}/`
      + `submodels`;
    return this.http.get<CarSubmodel[]>(api).toPromise();
  }

  getCarOptions(make: string, year: string, model: string, submodel: string): Promise<CarOptionCombinedDescription[]> {
    var currentRegion = sessionStorage.getItem("vehicleCountry");
    this.staggeredCar = false;
    this.region = currentRegion != null ? currentRegion : "Canada";
    const api = `${this.apiEndpoint}/${this.region}/`
      + `makes/${Helper.encodeURIComponent2(make)}/`
      + `years/${Helper.encodeURIComponent2(year)}/`
      + `models/${Helper.encodeURIComponent2(model)}/`
      + `submodels/${Helper.encodeURIComponent2(submodel)}/`
      + `options?tireFirst=${Helper.isProductTypePreferenceTire()}`;
    return this.http.get<CarOptionCombinedDescription[]>(api).toPromise();
  }

  getCarDetails(carDetails: MakeYearModel): Promise<CarDetails> {
    var currentRegion = sessionStorage.getItem("vehicleCountry");
    this.staggeredCar = false;
    this.region = currentRegion != null ? currentRegion : "Canada";
    const api = `${this.apiEndpoint}/${this.region}/`
      + `makes/${Helper.encodeURIComponent2(carDetails.make)}/`
      + `years/${Helper.encodeURIComponent2(carDetails.getYearStr)}/`
      + `models/${Helper.encodeURIComponent2(carDetails.model)}/`
      + `submodels/${Helper.encodeURIComponent2(carDetails.submodel)}/`
      + `options/${Helper.encodeURIComponent2(carDetails.option)}/`
      + `details?tireFirst=${Helper.isProductTypePreferenceTire()}`;
    return this.http.get<CarDetails>(api).toPromise();
  }

  getCarOemData(carDetails: MakeYearModel): Promise<VehicleOemDataDtoResponse> {
    var currentRegion = sessionStorage.getItem("vehicleCountry");
    this.staggeredCar = false;
    this.region = currentRegion != null ? currentRegion : "Canada";
    const api = `${this.apiEndpoint}/${this.region}/makes/oem-data`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' }).append('dataType', 'json');
    return this.http.post<VehicleOemDataDtoResponse>(api, JSON.stringify(carDetails), { headers: headers }).toPromise();
  }

  setCarStaggered(staggered: boolean) {
    this.staggeredCar = staggered;
  }

  getCarStaggered(): boolean {
    return this.staggeredCar;
  }
}
